export default __webpack_public_path__ + "static/media/event-product.5318c94d.jpg";